// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-messages-edit {
  padding-top: 20px;
}
.system-messages-edit .system-messages-edit-item .ant-radio div,
.system-messages-edit .system-messages-edit-item .ant-checkbox div {
  all: unset;
}
.system-messages-edit .system-messages-edit-item .action-buttons {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
}
.system-messages-edit .system-messages-edit-item .ant-form-item .ant-picker {
  width: 100%;
}
.system-messages-edit .system-messages-edit-item .body-form-item-errored label {
  color: red !important;
}
.system-messages-edit .system-messages-edit-item .body-form-item-errored div[role='application'] {
  border-color: red;
}
.system-messages-edit .ant-form-item-label {
  min-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/components/system-messages/edit-item/styles.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAFA;;EAOQ,UAAA;AADR;AANA;EAYM,aAAA;EACA,yBAAA;EACA,aAAA;AAHN;AAXA;EAmBQ,WAAA;AALR;AAdA;EAyBQ,qBAAA;AARR;AAjBA;EA6BQ,iBAAA;AATR;AApBA;EAmCI,gBAAA;AAZJ","sourcesContent":[".system-messages-edit {\n  padding-top: 20px;\n\n  .system-messages-edit-item {\n    .ant-radio,\n    .ant-checkbox {\n      div {\n        all: unset;\n      }\n    }\n\n    .action-buttons {\n      display: flex;\n      justify-content: flex-end;\n      padding: 10px;\n    }\n\n    .ant-form-item {\n      .ant-picker {\n        width: 100%;\n      }\n    }\n\n    .body-form-item-errored {\n      label {\n        color: red !important;\n      }\n\n      div[role='application'] {\n        border-color: red;\n      }\n    }\n  }\n\n  .ant-form-item-label {\n    min-width: 240px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
